import { DeploymentAlertAPI } from '@analyzer/client';
import { Alert, AlertTitle, Box, Card, CardContent, Typography } from '@mui/material';
import SummarizedLink from '../url.js';
import { getSeverityColor } from './severity.js';

export function DeploymentAlert(alert: DeploymentAlertAPI) {
  const { severity } = alert;

  return (
    <Box>
      <Alert severity={getSeverityColor(severity)} sx={{ mb: 2 }}>
        <AlertTitle>New Deployment Detected</AlertTitle>
        <Typography variant="body2">
          A new deployment of the target website was detected. If this was unexpected, please investigate
          further to ensure everything is working as intended.
        </Typography>
      </Alert>

      <Card>
        <CardContent>
          <Typography variant="h6">Details</Typography>
          <Typography variant="body2">Current Version: {alert.signature}</Typography>
          <Typography variant="h6" gutterBottom sx={{ mt: 2 }}>
            Bundle Scripts
          </Typography>
          {alert.requests.map((item, index) => (
            <Typography key={index} variant="body2">
              <SummarizedLink url={item.request_url} />
            </Typography>
          ))}
        </CardContent>
      </Card>
    </Box>
  );
}
